import { supabase } from './supabase';

// Demande la suppression du compte de l'utilisateur connecté. Le JWT est attaché
// automatiquement par functions.invoke ; l'edge function dérive l'uid du JWT (aucun
// identifiant n'est transmis). Lève une erreur si la suppression échoue.
// `codeApple` : code d'autorisation demandé à Apple juste avant, pour que le serveur révoque le jeton
// « Sign in with Apple » (exigence App Store). Absent pour les autres comptes.
export async function requestAccountDeletion(codeApple?: string): Promise<void> {
  const { data, error } = await supabase.functions.invoke<{ deleted: boolean }>('delete-account', {
    body: codeApple ? { codeApple } : {},
  });
  // L'edge function pose le filet de restauration AVANT toute destruction : un échec signifie donc
  // qu'ELLE N'A RIEN SUPPRIMÉ. Le message doit le dire — laisser croire à une suppression aboutie
  // pousserait à ne pas réessayer, en croyant le compte parti. Les écrans y ajoutent « Réessaie. ».
  if (error || !data?.deleted) {
    throw new Error(
      'Ton compte n’a pas été supprimé : l’opération a échoué avant toute suppression, tes données sont intactes.',
    );
  }
}
